import {
  ARGUMENTATION_UPLOAD_LINK_REQUEST,
  ARGUMENTATION_UPLOAD_LINK_SUCCESS,
  ARGUMENTATION_UPLOAD_LINK_ERROR,
} from "store/actions";

export function argumentationUploadReducer(state, action) {
  switch (action.type) {
    case ARGUMENTATION_UPLOAD_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };
    case ARGUMENTATION_UPLOAD_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };
    case ARGUMENTATION_UPLOAD_LINK_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}

export default argumentationUploadReducer;
